module.exports = __webpack_public_path__ + "fonts/SourceCodePro-Bold.98067d34.ttf";